import { Producto, Productos } from '@/interface/producto.model';
import { FechaFunctionsService } from '@/utils/functions.service';
import { pedidoFolioSearchText } from '@/utils/pedido-folio';
import { DatePipe } from '@angular/common';
import { Component, EventEmitter, Input, Output, SimpleChanges, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { GeneralService } from '@services/general.service';
import { LoadingService } from '@services/loading.service';
import { DatatableComponent } from '@swimlane/ngx-datatable';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-lista-pedidos',
  templateUrl: './lista-pedidos.component.html',
  styleUrls: ['./lista-pedidos.component.scss']
})
export class ListaPedidosComponent {
  @Input() label: string = "Todos los pedidos";
  @Input() rows: Array<any>;
  @Input() tempRows: Array<any>;
  @Input() isLoading: boolean = false;
  @Input() mini: boolean = false;
  @Input() onlyMedioPago: boolean = false;
  @Input() showCliente: boolean = true;
  @Input() showHeader: boolean = true;
  @Input() showFooter: boolean = true;
  @Input() sortByKey: string = 'fecha_termino';
  @Input() reverseSort: boolean = true;
  @Output() updateData = new EventEmitter();
  @Output() updateDataMedioPago = new EventEmitter();
  @ViewChild('table') table: DatatableComponent;
  nowDay: string = this.FechaFunc.NowDay();
  nextDay: string = this.FechaFunc.NextDay();
  messages: any;
  itemsPerPage: number = 50;
  page: number = 1;
  estados: Array<any>;

  constructor(private router: Router,
    public generalService: GeneralService,
    private toastr: ToastrService,
    public FechaFunc: FechaFunctionsService,
    public loadingService: LoadingService) {
  }

  ngOnInit() {
    this.getEstados();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (this.rows) {
      this.initSortData()
      this.getIcon(this.sortByKey)
    }
  }

  updateFilter(event) {
    const val = event.target.value.toLowerCase();

    // filter our data (folio = numero_pedido; id_pedido sigue en API/navegación)
    const temp = this.tempRows.filter(function (d) {
      const datepipe: DatePipe = new DatePipe('en-US')
      return pedidoFolioSearchText(d).indexOf(val) !== -1 || datepipe.transform(d.fecha_ingreso, 'dd/MM/yyyy').toLowerCase().indexOf(val) !== -1 || datepipe.transform(d.fecha_termino, 'dd/MM/yyyy').toLowerCase().indexOf(val) !== -1 || d.total_venta_format.toLowerCase().indexOf(val) !== -1 || d.estado.nombre_estado.toLowerCase().indexOf(val) !== -1 || d.cliente.nombre_completo.toLowerCase().indexOf(val) !== -1 || !val;
    });

    // update the rows
    this.rows = temp;
    // Whenever the filter changes, always go back to the first page
    this.table.offset = 0;
  }


  // Open/close panel  
  toggleExpandRow(row, expanded) {
    this.table.rowDetail.toggleExpandRow(row);
    if (!expanded) {
      this.table.rowDetail.collapseAllRows();
      this.table.rowDetail.toggleExpandRow(row);
    }
    else if (expanded) {
      this.table.rowDetail.collapseAllRows();
    }
  }

  save(row, rowIndex) {
  }

  updateRows() {
    this.updateData.emit()
  }

  EditaPedido(idPedido) {
    this.loadingService.setLoading(true);
    localStorage.setItem('idPedido', idPedido);
    this.router.navigate(['/pedido']);
  }

  goDetalleCliente(idCliente) {
    this.loadingService.setLoading(true);
    localStorage.setItem('idCliente', idCliente);
    this.router.navigate(['/cliente']);
  }


  pageChanged(event) {
    this.itemsPerPage = event.itemsPerPage
    this.page = event.page
  }

  initSortData() {
    // Crear una copia mutable del array
    const sortedArray = [...this.rows];
    // Ordenar la copia mutable del array
    sortedArray.sort((a, b) => {
      const key = this.sortByKey.split('.')

      const valueA = key.length == 2 ? a[key[0]][key[1]] : a[this.sortByKey];
      const valueB = key.length == 2 ? b[key[0]][key[1]] : b[this.sortByKey];

      if (valueA < valueB) {
        return this.reverseSort ? 1 : -1;
      } else if (valueA > valueB) {
        return this.reverseSort ? -1 : 1;
      } else {
        return 0;
      }
    });

    // Asignar la copia ordenada al array original
    this.rows = sortedArray;
  }

  sortData(key: string) {
    if (this.sortByKey === key) {
      this.reverseSort = !this.reverseSort;
    } else {
      this.sortByKey = key;
      this.reverseSort = false;
    }

    // Crear una copia mutable del array
    const sortedArray = [...this.rows];
    // Ordenar la copia mutable del array
    sortedArray.sort((a, b) => {
      const key = this.sortByKey.split('.')

      const valueA = key.length == 2 ? a[key[0]][key[1]] : a[this.sortByKey];
      const valueB = key.length == 2 ? b[key[0]][key[1]] : b[this.sortByKey];

      if (valueA < valueB) {
        return this.reverseSort ? 1 : -1;
      } else if (valueA > valueB) {
        return this.reverseSort ? -1 : 1;
      } else {
        return 0;
      }
    });

    // Asignar la copia ordenada al array original
    this.rows = sortedArray;
  }

  getIcon(key: string): string {
    //Yo uso iconos font-awesome de ahí la nomenclatura
    var iconClass = "fa fa-sort";

    if (this.sortByKey.indexOf(key) != -1) {
      iconClass = this.reverseSort ? 'fa fa-sort-down' : 'fa fa-sort-up';
    }

    return iconClass;
  }


  getEstados() {
    this.generalService.getListar("estado")
      .then(res => {
        this.estados = res.data;
      })
      .catch(err => console.error(err))
  }

  updateMetodoPago(e, id_pedido, id_cliente) {
    this.generalService
      .postCrear("detalle_pago", {
        id_pedido: id_pedido,
        metodoPago: [{
          fecha_pago: e.fecha_pago,
          hora_pago: e.hora_pago,
          id_tipopago: e.id_tipopago,
          tipoPagoText: e.tipoPagoText,
          referencia: e.referencia,
          total: e.total
        }]
      })
      .then(res => {
        this.toastr.success("Metodo de pago registrado exitosamente.")
        this.updateDataMedioPago.emit(id_cliente);
      })
      .catch(err => {
        this.toastr.error("Error al guardar metodo de pago")
      })
  }

}
